var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"hola",attrs:{"title":(_vm.getLoggedIn) ? _vm.getUsername : ' &nbsp;'}},[_vm._v(_vm._s((_vm.getLoggedIn) ? _vm.username : 'a  '))])}
var staticRenderFns = []

export { render, staticRenderFns }